import Grid from '@material-ui/core/Grid';
import { createStyles, IconButton, makeStyles, Theme, ThemeOptions } from '@material-ui/core';

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { baseTheme } from '../../../../theme';
import PostHighlightItem from './post-highlight-item';
import { AddCircleOutlineRounded } from '@material-ui/icons';
import moment from 'moment';
import { setPostHighlightsAction } from '../../../../store/posts/actions';
import { createHighlight } from '../../../../services/posts';

const toolBarColorPicker = (typeResolver: string | undefined) => {
  return typeResolver === 'Public'
    ? 'rgba(65, 0, 153, 1.0)'
    : typeResolver === 'Private'
      ? 'rgba(0, 101, 207, 1.0)'
      : 'rgba(0, 0, 0, 1.0)';
};

const useStyles = (
  theme: ThemeOptions,
  typeResolver: string | undefined) =>
  makeStyles((theme: Theme) =>
    createStyles({
      root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        '& .MuiIconButton-root': {
          color: toolBarColorPicker(typeResolver),
        },
      },
    }),
  );

export default function PostHighlights(props: any) {
  const { postId, highlights, typeResolver } = props;
  const classes = useStyles(baseTheme, typeResolver)();
  const currUser = useSelector((state: any) => state.auth.currUser);
  const dispatch = useDispatch();

  const setOrder = highlights?.length ? highlights.length : 0;
  const addPostHighLight = async () => {
    const response: any = await createHighlight(postId, currUser.uid, setOrder);
    const existingHighlights = highlights || [];
    dispatch(
      setPostHighlightsAction({ highlights: [...existingHighlights, response] }),
    );
  };

  const orderSort = (a: any, b: any) => {
    if (a.order < b.order) {
      return -1;
    }

    if (a.order > b.order) {
      return 1;
    }

    return 0;
  };

  return (
    <Grid item container direction="column" className={classes.root} spacing={2}>
      <Grid item>
        <h3>Highlights</h3>

        Add highlight background image and short highlights BEFORE posting LIVE.
        <br />
        Click "+" to add highlight.
        <IconButton onClick={addPostHighLight}>
          <AddCircleOutlineRounded />
        </IconButton>
      </Grid>

      <Grid item container direction="column" spacing={1}>
        {highlights && highlights
          .sort(orderSort)
          .map((item: any, index: number) =>
            <PostHighlightItem key={index} {...item} />)}
      </Grid>
    </Grid>
  );
}
